import { apiEscolaridadObtenerConfiguracion } from "../API";
import { IApiResult, IConfiguration } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

export const _ESCOLARIDAD_CONFIGURACION_MAP: Map<number, IConfiguration> = new Map();
let maxDateConfiguration: string | null = null;

export function _SvEscolaridadObtenerConfiguracion(idEscolaridad: number, callback: (status: number, result: Array<IConfiguration>) => void, resetMaxDate: boolean = false) {
    if (resetMaxDate) maxDateConfiguration = null;

    let params = {
        IdEscolaridad: idEscolaridad,
        Modificacion: maxDateConfiguration
    }

    if (maxDateConfiguration == null)
        _ESCOLARIDAD_CONFIGURACION_MAP.clear();

    new RequestData<IApiResult<IConfiguration[]>>(apiEscolaridadObtenerConfiguracion)
        .Params(params)
        .Completion((response, error) => {
            let status = response ? response.Resultado : -111;

            if (error)
                console.log(error?.name, error?.message);

            const resultData = response?.Datos || [];
            resultData.forEach(item => {
                if (!item.EnUso)
                    _ESCOLARIDAD_CONFIGURACION_MAP.delete(item.Id)
                else
                    _ESCOLARIDAD_CONFIGURACION_MAP.set(item.Id, item);
            });

            let maxDate = response?.Maxima || null;
            if (resultData.length > 0 && maxDate != null)
                maxDateConfiguration = maxDate;

            if (callback) callback(status, resultData);
        }).Get();
}